import React, { useEffect, useState } from "react";
// reactstrap components
import {
  Card,
  Container,
  CardHeader,
  CardBody,
  Table,
  Row,
  Col,
  Button,
} from "reactstrap";
// core components
import Header from "components/Headers/Header.js";
import { connect } from "react-redux";
import Unauthorized from "views/Pages/Unauthorized";
import {
  fetchItemLocationListing,
  fetchItemLocationListingSuccess,
} from "../../redux/ItemLocation/itemLocationAction";
import { GetApiActionWithAuthorization, PostApiWithAuthorizationAction } from "../../constantFunctions/apiActions";
import EditItemLocationModal from "views/Modal/ItemLocations/EditItemLocationModal";
import { toast } from "react-toastify";
import { resetState } from "../../redux/common/commonAction";
import AddNewItemLocationModal from "views/Modal/ItemLocations/AddNewItemLocationModal";
import ConfirmationDeleteModal from "views/Modal/ConfirmationDeleteModal";
import { DropdownList } from "react-widgets";
import { displayOrderTypeOptions } from "constants/ticketConstants";

function ItemLocation(props) {
  const [unauthorized, setUnauthorized] = useState(false);
  const [addModal, setAddModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [editData, setEditData] = useState({});
  const [confirm, setConfirm] = useState(false);
  const [delId, setDelId] = useState("");

  useEffect(() => {
    props.fetchItemLocationListing();
  }, []);

  if (props.itemLocations.error && !unauthorized) {
    if (props.itemLocations.error.status === 403) {
      setUnauthorized(true);
    } else if (props.itemLocations.error.status === 440) {
      props.resetState();
      toast.error(props.itemLocations.error.message, {
        position: toast.POSITION.TOP_CENTER,
      });
      props.history.push("/auth/login");
    }
  }

  const toggleAdd = (e) => {
    setAddModal(!addModal);
  };

  const toggleEdit = (id = "", name = "") => {
    setEditData({ id, name });
    setEditModal(!editModal);
  };

  const toggleConfirm = (id = "") => {
    setDelId(id);
    setConfirm(!confirm);
  };

  const confirmed = (e) => {
    GetApiActionWithAuthorization("common/delete-item-location/" + delId)
      .then((res) => {
        props.fetchItemLocationListingSuccess(res.data);
        //toast.success(res.message, { position: toast.POSITION.TOP_CENTER });
        setConfirm(false);
      })
      .catch((err) => {
        console.log(err);
        if (err.status === 403) {
          setUnauthorized(true);
        } else if (err.status === 440) {
          props.resetState();
          toast.error(err.message, { position: toast.POSITION.TOP_CENTER });
          props.history.push("/auth/login");
        }
      });
  };

  const renderTicketsTableData = (e) => {
    return props.itemLocations.allItemLocations.map((booth, i) => {
      return (
        <tr key={i}>
          <td>
            [
            <span
              id={"update-booth" + i}
              className="delete-item"
              onClick={(e) => {
                toggleEdit(booth.id, booth.name);
              }}
            >
              Edit
            </span>
            ]{" "}[
            <span
              id={"delete-item-location" + i}
              className="delete-item"
              onClick={(e) => toggleConfirm(booth.id)}
            >
              Delete
            </span>
            ]
          </td>
          <td>{booth.name}</td>
        </tr>
      );
    });
  };

  return unauthorized ? (
    <Unauthorized />
  ) : (
    <>
      <Header />
      {/* Page content */}
      <Container className="mt--9 main-content" fluid>
        <Card className="card-height shadow">
          <CardHeader>
            <div className="text-center">
              <h1>Item Locations</h1>
            </div>
          </CardHeader>
          <CardBody>
            <Row className="mb-3">
              <Col md="9" className="search-left-btn">
                <Button id="add-new" color="primary" onClick={toggleAdd}>
                  Add New+
                </Button>
              </Col>
              <Col md="3" className="search-left-btn"></Col>
            </Row>
            <Table className="ticket-table table-listing" responsive bordered>
              <thead className="thead-light">
                <tr>
                  <th scope="col">Action</th>
                  <th scope="col">Name</th>
                </tr>
              </thead>
              <tbody>{renderTicketsTableData()}</tbody>
            </Table>
          </CardBody>
        </Card>
      </Container>
      {addModal && (
        <AddNewItemLocationModal {...props} show={addModal} toggle={toggleAdd} />
      )}
      {editModal && (
        <EditItemLocationModal
          {...props}
          show={editModal}
          editData={editData}
          toggle={toggleEdit}
        />
      )}
      {confirm && (
        <ConfirmationDeleteModal
          show={confirm}
          toggle={toggleConfirm}
          confirmed={confirmed}
        />
      )}
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    itemLocations: state.itemLocationReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchItemLocationListing: (params) => dispatch(fetchItemLocationListing(params)),
    fetchItemLocationListingSuccess: (data) => dispatch(fetchItemLocationListingSuccess(data)),
    addUpdatedData: (data) => dispatch(fetchItemLocationListingSuccess(data)),
    resetState: () => dispatch(resetState()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ItemLocation);
